import { ReactElement } from 'react'
import TextBox from '../Textboxs/Textbox'
import classses from './Typeahead.module.scss'
import { TextBoxTypeEnum } from '../../../enums/TextBoxTypeEnum'
import { useState, useEffect } from 'react'
const Typeahead: React.FC<TypeaheadInterface> = ({
  Regular,
  RxgMessage,
  className,
  id,
  innerText,
  isLtR,
  isRequired,
  onChange,
  isReadOnly,
  debounceTime,
  onFocus,
  onBlur,
  value,
  children,
  onClick,
  setRef,
}) => {
  const [valueTypeahead, setValueTypeahead] = useState<
    string | null | undefined
  >(value)
  useEffect(() => {
    setValueTypeahead(value)
  }, [value])
  return (
    <>
      <div className={classses['typeahead']}>
        <div className='flex justify-center items-center gap-1'>{children}</div>
        <TextBox
          innerText={innerText}
          Type={TextBoxTypeEnum.Text}
          onChange={onChange}
          value={valueTypeahead ?? ''}
          onBlur={onBlur}
          setRef={setRef}
          onFocus={onFocus}
          debounceTime={debounceTime}
          isReadOnly={isReadOnly}
          isRequired={isRequired}
          id={id}
          onClick={onClick}
          isLtR={isLtR}
          RxgMessage={RxgMessage}
          Regular={Regular}
          className={`${
            classses['typeahead__textbox']
          } !border-0 !ring-0 focus:!ring-0  !rounded-none ${className ?? ''}`}
        />
      </div>
    </>
  )
}

const ProvideTypeahead: React.FC<{
  children: ReactElement
  className?: string
  showList?: boolean
  listChildren?: ReactElement
  classChildren?: string
}> = ({ children, className, listChildren, showList, classChildren }) => (
  <>
    <div className={`relative w-full  ${className} `}>
      {children}
      <div
        className={`${
          showList ? 'block' : 'hidden '
        } absolute w-full ring-2 ring-white top-full bg-white/40 backdrop-blur-lg  z-[99] md:w-1/2 md:-translate-x-1/2 ${classChildren}`}
      >
        {listChildren}
      </div>
    </div>
  </>
)
export { ProvideTypeahead }
export default Typeahead
